class ProductOptions extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.gallery = document.querySelector(".mediaGallery-container");
    this.addEventListener("click", this.productOptionsEventHandler.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener(
      "click",
      this.productOptionsEventHandler.bind(this)
    );
  }

  productOptionsEventHandler(event) {
    const currentBtn = event.target.closest("button");
    if (!currentBtn.getAttribute("data-option-handle")) return;
    const { optionHandle } = currentBtn.dataset;
    this.changeOptionsActiveState(currentBtn);
    this.updateGallery(optionHandle);
    this.updateOptionName(currentBtn);
  }

  changeOptionsActiveState(currentBtn) {
    const currentSelectorsContainer = currentBtn.closest(
      ".selectors-container"
    );
    const prevBtn = currentSelectorsContainer.querySelector(
      `button[data-variant-selected="true"]`
    );
    prevBtn.dataset.variantSelected = false;
    currentBtn.dataset.variantSelected = true;
  }

  updateGallery(optionHandle) {
    const altTextList = this.gallery?.getAttribute("data-alt-text-list");
    if (this.gallery && altTextList.indexOf(optionHandle) > -1) {
      this.gallery.setAttribute("data-active-variant-handle", optionHandle);
    }
  }

  /**
   * Updates the option name displayed in the product option selector.
   * 
   * This method updates the label of a product option based on the dataset of the 
   * currently selected button. It also aligns the label with the corresponding button 
   * by setting its index as a data attribute.
   * 
   * @param {HTMLElement} currentBtn - The button element that was clicked or selected. 
   *                                   It should have a `data-option-name` attribute.
   */
  updateOptionName(currentBtn) {
    const dataset = currentBtn.dataset;
    const buttonSiblings = Array.from(currentBtn.parentElement.children);
    const index = buttonSiblings.indexOf(currentBtn);
    if (dataset.optionName) {
      const optionLabel = this.querySelector(
        "#product-option-selector--flavor"
      );
      if (!optionLabel) return;
      optionLabel.innerHTML = dataset.optionName;
      optionLabel.setAttribute("data-option-index", index);
    }
  }
}
customElements.define("product-options", ProductOptions);
